<template>
  <svg :width="width" :height="height" viewBox="0 0 25 25" fill xmlns="http://www.w3.org/2000/svg">
    <g :fill="color">
      <path d="M12.0508 24.4922C18.5898 24.4922 24.0039 19.0664 24.0039 12.5391C24.0039 6 18.5781 0.585938 12.0391 0.585938C5.51172 0.585938 0.0976562 6 0.0976562 12.5391C0.0976562 19.0664 5.52344 24.4922 12.0508 24.4922ZM12.0508 22.5C6.51953 22.5 2.10156 18.0703 2.10156 12.5391C2.10156 7.23047 6.16797 2.92969 11.3945 2.60156V12.7031C11.3945 12.9609 11.4531 13.1719 11.6758 13.3828L18.543 20.1094C16.8086 21.5977 14.5352 22.5 12.0508 22.5ZM12.9648 11.5195V2.61328C16.1406 2.90625 18.8711 4.66406 20.4766 7.20703L12.9648 11.5195ZM13.6211 12.9609L21.2031 8.60156C21.7188 9.80859 22.0117 11.1328 22.0117 12.5391C22.0234 14.9883 21.1445 17.2266 19.6914 18.9609L13.6211 12.9609Z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>
